import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import registerServiceWorker from './registerServiceWorker';
import "./utlis/translations/i18n";

import '@blueprintjs/core/lib/css/blueprint.css';
import '@blueprintjs/icons/lib/css/blueprint-icons.css';
import 'flexboxgrid/dist/flexboxgrid.css';
import 'animate.css/animate.css'
import './assets/style.css';

ReactDOM.render(<App />, document.getElementById('root'));
registerServiceWorker();